import { useEffect, useState } from "react";
import { Select, Input, message } from "antd";
import { INGREDIENT_UNITS } from "../../../constant/constants";
import { getUnitAndCostFromIngredientId } from "../../../services/inventory/recipe.service";
import CustomInputNumber from "../../CustomInputNumber";
import { roundNumber } from "../../../utils/Common";

export default function IngredientInput({
  isCategorySelected,
  tempVariantId,
  allIngredients,
  currentIngredient,
  ingredientDropdownData,
  updateRecipeVariantField = () => {},
}) {
  const { ingredientName, ingredientId, quantity, recipeUnit, recipeUnitPrice, cost, tempIngredientId } =
    currentIngredient || {};
  const [itemName, setItemName] = useState("");
  const [itemQty, setItemQty] = useState(1);
  const [itemUnit, setItemUnit] = useState("");
  const [itemUnitPrice, setItemUnitPrice] = useState(0);
  const [ingredientCost, setIngredientCost] = useState(0);

  /** init component */
  useEffect(() => {
    setItemName(Boolean(ingredientName) ? ingredientName : "");
    setItemQty(quantity);
    setItemUnit(recipeUnit || "");
    setItemUnitPrice(Number(recipeUnitPrice) || 0);
    setIngredientCost(Number(cost) || 0);
  }, [currentIngredient]);

  useEffect(() => {
    updateRecipeVariantField("ingredients", tempVariantId, tempIngredientId, "ingredientId", "");
  }, []);

  function onHandleItemName(val) {
    setItemName(val);
    updateRecipeVariantField("ingredients", tempVariantId, tempIngredientId, "ingredientName", val);
    if (val) {
      const { unit, unitPrice } = getUnitAndCostFromIngredientId(allIngredients, val);

      updateRecipeVariantField("ingredients", tempVariantId, tempIngredientId, "recipeUnit", unit);
      updateRecipeVariantField("ingredients", tempVariantId, tempIngredientId, "recipeUnitPrice", unitPrice);

      setItemUnit(unit);
      setItemUnitPrice(unitPrice);
    }
  }

  function onHandleItemQty(val) {
    const itemQuantity = val;
    
    updateRecipeVariantField("ingredients", tempVariantId, tempIngredientId, "quantity", itemQuantity);
    setItemQty(itemQuantity);
  }

  function getIngredientCost(qty, unitPrice) {
    return roundNumber(Number(qty) * Number(unitPrice));
  }

  /** calculate ingredient cost */
  useEffect(() => {
    let tempCost = getIngredientCost(itemQty, itemUnitPrice);
    updateRecipeVariantField("ingredients", tempVariantId, tempIngredientId, "cost", tempCost);
    setIngredientCost(tempCost);
  }, [itemQty, itemUnitPrice]);

  return (
    <section className="flex space-x-3">
      <div className="w-[204px] h-[32px]">
        <Select
          disabled={!isCategorySelected}
          showSearch
          value={itemName}
          name="itemName"
          style={{ width: "100%", height: "100%" }}
          onChange={onHandleItemName}
          options={ingredientDropdownData}
          optionFilterProp="label"
          filterSort={(optionA, optionB) =>
            (optionA?.label ?? "").toLowerCase().localeCompare((optionB?.label ?? "").toLowerCase())
          }
        />
      </div>
      <div className="w-[80px] h-[32px]">
        <CustomInputNumber 
          placeholder={'Qty'}
          value={itemQty}
          setValue={onHandleItemQty}
          isDecimalAllowed={true}
          disabled={!isCategorySelected}
          min={0}
          max={99999}
        />
      </div>
      <div className="w-[123px] h-[32px]">
        <Select
          disabled
          value={itemUnit}
          name="itemUnit"
          style={{ width: "100%", height: "100%" }}
          options={INGREDIENT_UNITS}
        />
      </div>
      <div className="w-[108px] h-[32px]">
        <Input
          disabled
          type="number"
          value={Number(ingredientCost)?.toFixed(2)}
          name="cost"
          className="w-full h-full"
          placeholder="Unit price"
        />
      </div>
    </section>
  );
}
